export default (arr, val = 'id') => {
  if (!Array.isArray(arr)) return arr;
  const uniqueValues = new Set();
  return arr.filter((el) => {
    const isDuplicate = uniqueValues.has(el[val]);
    uniqueValues.add(el[val]);
    return !isDuplicate;
  });
};
